import React, { useState, useEffect } from "react";
import { HiOutlineNewspaper } from "react-icons/hi2";
import { TfiLayoutSlider } from "react-icons/tfi";
import { FaUserEdit } from "react-icons/fa";
import { RiDashboardFill } from "react-icons/ri";
import { FcContacts } from "react-icons/fc";
import { FaMedal } from "react-icons/fa";
import { BiLogOut } from "react-icons/bi";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { logoutAccess } from "../store/stateFunctions";
import { CiShoppingCart } from "react-icons/ci";
import { AiFillHome, AiFillPlusCircle, AiOutlineNumber } from "react-icons/ai";
import { MdEvent, MdClose } from "react-icons/md";
import { HiMenuAlt3 } from "react-icons/hi";
import "./Sidebar.css";

const Sidebar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  const handleLogout = () => {
    logoutAccess("Super Admin"); // Redux logout
    navigate("/super-admin"); // <-- redirect to login page
  };
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('.sidebar-container')) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const menuItems = [
    {
      section: 'main',
      title: 'Main',
      items: [
        { to: "/super-admin/adminhome", icon: AiFillHome, label: "Home" },
        { to: "/super-admin/addslider", icon: TfiLayoutSlider, label: "Manage Slider" },
        { to: "/super-admin/addaboutus", icon: AiFillPlusCircle, label: "Add About Us" },
        { to: "/super-admin/addproduct", icon: AiFillPlusCircle, label: "Add Vision & Mission" },
        { to: "/super-admin/addcertification", icon: RiDashboardFill, label: "Manage ChairWoman's Message" },

      ]
    },

    {
      section: 'content',
      title: 'Content Management',
      items: [

        { to: "/super-admin/addawards", icon: FaMedal, label: "News " },
        { to: "/super-admin/addgallery", icon: RiDashboardFill, label: "Manage Gallery" },
        { to: "/super-admin/addnews", icon: HiOutlineNewspaper, label: "Manage CSR Intiatives" },
        { to: "/super-admin/addblock", icon: HiOutlineNewspaper, label: "Manage Blogs" },
        { to: "/super-admin/agniveerlist", icon: HiOutlineNewspaper, label: "Agniveer List" },
        { to: "/super-admin/volunteerlist", icon: FaUserEdit, label: "Volunteer List" },
      ]
    },
    // {
    //   section: 'projects',
    //   title: 'Media',
    //   items: [
    //     { to: "/super-admin/addagroproject", icon: AiFillPlusCircle, label: "Agro Project" },
    //     { to: "/super-admin/addapicultureproject", icon: AiFillPlusCircle, label: "Apiculture Project" },
    //     { to: "/super-admin/addbiocngproject", icon: AiFillPlusCircle, label: "Bio CNG Project" },
    //     { to: "/super-admin/adddairyproject", icon: AiFillPlusCircle, label: "Dairy Project" },
    //     { to: "/super-admin/addgeraniumproject", icon: AiFillPlusCircle, label: "Geranium Project" },
    //     { to: "/super-admin/addcashewproject", icon: AiFillPlusCircle, label: "Cashew Project" },
    //     { to: "/super-admin/addvermiproject", icon: AiFillPlusCircle, label: "Vermicompost Project" },
    //     { to: "/super-admin/addfisheryproject", icon: AiFillPlusCircle, label: "Fishery Project" },
    //     { to: "/super-admin/addpearlfarmingproject", icon: AiFillPlusCircle, label: "Pearl Farming Project" },
    //     { to: "/super-admin/addjivamrutproject", icon: AiFillPlusCircle, label: "Jivamrut Project" },
    //     { to: "/super-admin/addpanchgavyaproject", icon: AiFillPlusCircle, label: "Panchgavya Project" },
    //     { to: "/super-admin/addpaintproject", icon: AiFillPlusCircle, label: "Paint Project" },
    //     { to: "/super-admin/addsoilresearch", icon: AiFillPlusCircle, label: "Soil, Water & Petiole Testing Lab" },
    //     { to: "/super-admin/addprojectslider", icon: TfiLayoutSlider, label: "Project Slider Images" },
    //   ]
    // },

  ];

  return (
    <>
      {/* Top Navigation Bar */}
      <nav className="top-navbar">
        <div className="navbar-content">
          <button
            className="menu-toggle-btn"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <HiMenuAlt3 />
            <span>Menu</span>
          </button>

          <div className="brand-title">
            <NavLink to="/" className="brand-link">
              Venkateshwara Farmer Welfare Foundation
            </NavLink>
          </div>

          <button
            className="logout-btn"
            onClick={handleLogout} // <-- updated
            aria-label="Logout"
          >
            <BiLogOut />
            <span>Logout</span>
          </button>
        </div>
      </nav>

      {/* Overlay */}
      {isMenuOpen && <div className="sidebar-overlay" onClick={closeMenu}></div>}

      {/* Sidebar */}
      <div className={`sidebar-container ${isMenuOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <h3>Manage Website</h3>
          <button
            className="close-btn"
            onClick={closeMenu}
            aria-label="Close menu"
          >
            <MdClose />
          </button>
        </div>

        <div className="sidebar-content">
          {menuItems.map((section) => (
            <div key={section.section} className="menu-section">
              <div
                className={`section-header ${activeSection === section.section ? 'active' : ''}`}
                onClick={() => setActiveSection(activeSection === section.section ? '' : section.section)}
              >
                <h4>{section.title}</h4>
                <span className="section-toggle">
                  {activeSection === section.section ? '−' : '+'}
                </span>
              </div>

              <div className={`section-items ${activeSection === section.section ? 'expanded' : ''}`}>
                {section.items.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    onClick={closeMenu}
                    className={({ isActive }) =>
                      `sidebar-link ${isActive ? 'active' : ''}`
                    }
                  >
                    <item.icon className="sidebar-icon" />
                    <span>{item.label}</span>
                  </NavLink>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Spacer for fixed navbar */}
      <div className="navbar-spacer"></div>
    </>
  );
};

export default Sidebar;
